// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE STEP 1–3 QUESTIONS — the borrower form's and the LO form's side of the ONE definition
// (constants/applicationQuestions.json, a byte-for-byte copy of backend/constants/applicationQuestions.json, made by
// backend scripts/syncApplicationQuestions.js; backend test/applicationQuestions.test.js fails if they differ). The
// helpers are the backend module's (constants/applicationQuestions.js), line for line.
// ─────────────────────────────────────────────────────────────────────────────
import APPLICATION_QUESTIONS_JSON from './applicationQuestions.json';

export const DEF = APPLICATION_QUESTIONS_JSON;

const BY_KEY = Object.freeze(Object.fromEntries(DEF.questions.map((q) => [q.key, q])));
// The LO form's key(s) → { question, label }: one key, or several (the name: first and last, with a label each).
const BY_LO_KEY = Object.freeze(Object.fromEntries(DEF.questions.filter((q) => q.lo).flatMap((q) => (q.lo.keys
  ? q.lo.keys.map((k, i) => [k, { question: q, label: q.lo.labels[i] }])
  : q.lo.key ? [[q.lo.key, { question: q, label: q.lo.label || null }]] : []))));

/** The question for a form_data key (throws on an unknown key, so a typo is a failure, not an undefined label). */
export function question(key) {
  const q = BY_KEY[key];
  if (!q) throw new Error(`applicationQuestions: no question "${key}"`);
  return q;
}
/** The borrower's label. */
export const labelOf = (key) => question(key).label;
/** The borrower's options [{ value, label, hint? }]. */
export const optionsOf = (key) => question(key).options || [];
/** The LO form's label for a submission-vocabulary key. */
export function loLabel(loKey) {
  const hit = BY_LO_KEY[loKey];
  if (!hit || !hit.label) throw new Error(`applicationQuestions: no LO label for "${loKey}"`);
  return hit.label;
}
/** The income types a job title is required for (the job_title question's required rule). */
export const jobTitleTypes = () => question('job_title').required.when.includesAny;
/** The step-3 declaration questions [{ key, label }], in the form's order. */
export const declarationItems = () => question('declarations').items;
